import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRouterMap = [
  {
    path: "/404",
    component: () => import("@/views/404"),
    meta:{hidden: true},
  },
  {path: '/', redirect: "/home",},
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index"),
    meta: {title: "首页",customTitle:1},
  },
  {
    path: "/video",
    name: "video",
    component: () => import("@/views/video/index"),
    meta: {title: "视频"},
  },
  {
    path: "/topic",
    name: "topic",
    component: () => import("@/views/topic/index"),
    meta: {title: "练习"},
  },
  {
    path: "/special",
    name: "special",
    component: () => import("@/views/special/index"),
    meta: {title: "专项练习"},
  },
  {
    path: "/select",
    name: "select",
    component: () => import("@/views/select/index"),
    meta: {title: "精选题库"},
  },
  {
    path: "/practiceTest",
    name: "practiceTest",
    component: () => import("@/views/practiceTest/index"),
    meta: {title: "全真模拟"},
  },
  {
    path:"/teachLive",
    name:"teachLive",
    component: () => import("@/views/video/teachLive.vue"),
    meta: {title: "直播教学"},
  },
  {
    path:"/liveDetail",
    name:"liveDetail",
    component:() => import("@/views/video/liveDetail.vue"),
    meta: {title: "直播视频",customTitle:1},
  },
  {
    path:"/placeLib",
    name:"placeLib",
    component:() => import("@/views/placeLib/index"),
  },
  {
    path:"/mockScore",
    name:"mockScore",
    component:() => import("@/views/mockScore/index"),
  },
  {
    path:"/collect",
    name:"collect",
    component:() => import("@/views/collect/index"),
    meta: {title: "收藏题",customTitle:1},
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    meta: {title: "登录",hidden: true},
  },
  {
    path: "/changePsd",
    name: "changePsd",
    component: () => import("@/views/changePsd/index"),
    meta: {title: "修改密码",hidden: true},
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index"),
    meta: {title: "注册",hidden: true},
  },
  {path: "*", redirect: "/404"},
];

const router = new Router({
  routes: constantRouterMap
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js